import {Dispatch} from 'react'
import {SwipeEventData} from 'react-swipeable'

interface SliderNextAction {
  type: 'next'
  length: number
}

interface SliderPrevAction {
  type: 'prev'
  length: number
}

interface SliderJumpAction {
  type: 'jump'
  desired: number
}

interface SliderJumpWithoutAnimateAction {
  type: 'jump-without-animate'
  desired: number
}

interface SliderDoneAction {
  type: 'done'
}

interface SliderDragAction {
  type: 'drag'
  offset: number
}

export type SliderAction =
  | SliderJumpAction
  | SliderJumpWithoutAnimateAction
  | SliderNextAction
  | SliderPrevAction
  | SliderDragAction
  | SliderDoneAction

export const swipeHandler = (
  e: SwipeEventData,
  dispatch: Dispatch<SliderAction>,
  length: number,
  direction: number
) => {
  const threshold = 400
  const d = Math.abs(e.deltaX)

  if (d >= threshold) {
    dispatch({
      type: direction > 0 ? 'next' : 'prev',
      length
    })
  } else {
    dispatch({
      type: 'drag',
      offset: 0
    })
  }
}

export const swipingHandler = (
  e: SwipeEventData,
  dispatch: React.Dispatch<SliderAction>
) => {
  dispatch({
    type: 'drag',
    offset: e.deltaX
  })
}
